// @ vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;

// @ commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKMessage } = require('commonsComponents/OKMessage');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');

// @ components
const { CallMeBack } = require('components/callMeBack/callMeBack');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const ContactInfoBox = require('components/myProfile/contactInfoBox/contactInfoBox');
const OpenYoungContactDataStep1 = require('components/myProfile/openYoungContactData/openYoungContactDataStep1/openYoungContactDataStep1');
const OpenYoungContactDataStep2 = require('components/myProfile/openYoungContactData/openYoungContactDataStep2/openYoungContactDataStep2');
const OpenYoungContactDataSuccess = require('components/myProfile/openYoungContactData/openYoungContactDataSuccess/openYoungContactDataSuccess');
const OpenYoungContactDataError = require('components/myProfile/openYoungContactData/openYoungContactDataError/openYoungContactDataError');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const SignaturePatternButton = require('components/signaturePattern/signaturePatternButton/signaturePatternButton');

// @actions
const hireContactDataActions = require('actions/hireContactData');
const openYoungProfileDetailsActions = require('actions/openYoungProfileDetails');

// @utilities
const { PROC_OPEN_YOUNG_CONTACT_DATA } = require('utilities/tagging');

class OpenYoungContactDataEditView extends React.Component {

    constructor(props) {
        super(props);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount() {
        const {
            fillOpenYoungProfile,
            history,
            immOpenYoungProfileDetails
        } = this.props;
        if (immOpenYoungProfileDetails.get('fetchSuccess')) {
            fillOpenYoungProfile(immOpenYoungProfileDetails);
        } else {
            history.push(`/myprofile/openyoung-profiles`);
        }
    }

    componentWillUnmount() {
        this.props.reset();
    }

    handleCancel() {
        const { match: { params : {profileIndex} }, history } = this.props;
        history.push(`/myprofile/openyoung-profile-details/${profileIndex}`);
    }

    buildWizard() {
        const {
            immHireContactData,
            immOpenYoungProfileDetails,
            setVisibleStep,
            setWillCancel,
            updateProfileDetailsData,
            validateStep,
        } = this.props;

        const wizardActions = {
            cancel: this.handleCancel,
            finish: () => updateProfileDetailsData('contactData'),
            setVisibleStep,
            setWillCancel,
            validateStep
        };
        const immSteps = immOpenYoungProfileDetails.get('steps');

        return (
            <Wizard
                actions={wizardActions}
                immSteps={immSteps}
                processType={PROC_OPEN_YOUNG_CONTACT_DATA}
                showPreLeaveModal={true}
                stepsAmount={immSteps.size}
                visibleStep={immOpenYoungProfileDetails.get('visibleStep')}
            >
                <WizardStep
                    cancelButton={true}
                    position="first"
                >
                    <OpenYoungContactDataStep1
                        immHireContactData={immHireContactData}
                    />
                </WizardStep>
                <WizardStep
                    addLoadingBehaviour={true}
                    cancelButton={true}
                    onBackClick={false}
                    immFinalButton="openYoungContactData-openYoungContactData_submit"
                    position="last"
                    SignaturePatternButton={SignaturePatternButton}
                >
                    <OpenYoungContactDataStep2
                        immHireContactData={immHireContactData}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    buildWizardError() {
        const {immHireContactData, immOpenYoungProfileDetails} = this.props;
        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10">
                <OpenYoungContactDataError
                    immHireContactData={immHireContactData}
                    immOpenYoungProfileDetails={immOpenYoungProfileDetails}
                />
            </div>
        );
    }

    buildWizardSuccess() {
        const { immHireContactData, immOpenYoungProfileDetails } = this.props;
        return (
            <div className="col-xs-12 col-md-offset-1 col-md-10">
                <OpenYoungContactDataSuccess
                    immHireContactData={immHireContactData}
                    immOpenYoungProfileDetails={immOpenYoungProfileDetails}
                />
            </div>
        );
    }

    buildContactDataForm() {
        const content = this.buildWizard();
        const boxBody = (
            <OKMessage type="important">
                <FormattedText value="profile-boxBody" />
            </OKMessage>
        );
        const boxTitle = formatText('profile-boxTitle');
        return (
            <div>
                <div className="col-xs-12 col-md-8">
                    {content}
                </div>

                <div className="col-xs-12 col-md-4">
                    <div className="row">
                        <div className="col-xs-12 grid-view--variable-cell-separation">
                            <ContactInfoBox
                                boxTitle={boxTitle}
                                boxBody={boxBody}
                                hasMessage={true}
                            />
                        </div>
                        <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                            <CallMeBack pageTitle={formatText('breadcrumb-personalInformation')} hasEntrance={false} />
                        </div>
                        <div className="col-xs-12 grid-view--fix-cell-separation">
                            <CommercialAds path={'edit'} type="banner-a" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render () {
        const {immOpenYoungProfileDetails, match: { params: {profileIndex} } } = this.props;

        const breadcrumbConfig = [{
            text: formatText('breadcrumb-personalInformation'),
            url: '/myprofile/edit'
        }, {
            text: formatText('breadcrumb-breadcrumb_openYoungInformation'),
            url: '/myprofile/openyoung-profiles'
        }, {
            text: formatText('breadcrumb-breadcrumb_personalDataOpenYoungInformation'),
            url: `/myprofile/openyoung-profile-details/${profileIndex}`
        }, {
            text: formatText('breadcrumb-breadcrumb_editOpenYoungInformation'),
            url: ''
        }];

        let content;
        if (immOpenYoungProfileDetails.get('isFetching')) {
            content = (
                <OKSectionBox>
                    <LoadingSection />
                </OKSectionBox>
            );
        } else if (immOpenYoungProfileDetails.get('submitSuccessful')) {
            content = this.buildWizardSuccess();
        } else if (immOpenYoungProfileDetails.get('error')) {
            content = this.buildWizardError();
        } else if (immOpenYoungProfileDetails.get('fetchSuccess')){
            content = this.buildContactDataForm();
        }

        return (
            <div className="open-young-contact-data-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover>
                            <OKHeaderSubPage
                                breadcrumbConfig={breadcrumbConfig}
                                finalTitle={getFinalTitle('openYoungProfileDetails-openYoungProfileDetails_formsTitle')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {content}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

OpenYoungContactDataEditView.propTypes = {
    fillOpenYoungProfile: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immHireContactData: PropTypes.object,
    immOpenYoungProfileDetails: PropTypes.func.isRequired,
    match: PropTypes.object,
    reset: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    updateProfileDetailsData: PropTypes.func.isRequired,
    validate: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
}

module.exports.constructor = OpenYoungContactDataEditView;

module.exports.OpenYoungContactDataEditView = connect(
    state => ({
        immHireContactData: state.hireContactData,
        immOpenYoungProfileDetails: state.openYoungProfileDetails,
    }), {
        fillOpenYoungProfile: hireContactDataActions.fillOpenYoungProfile,
        reset: openYoungProfileDetailsActions.reset,
        setVisibleStep: openYoungProfileDetailsActions.setVisibleStep,
        setWillCancel: openYoungProfileDetailsActions.setWillCancel,
        updateProfileDetailsData: openYoungProfileDetailsActions.updateProfileDetailsData,
        validate: openYoungProfileDetailsActions.validate,
        validateStep: openYoungProfileDetailsActions.validateContactDataStep,
    }
)(withRouter(OpenYoungContactDataEditView));
